import React from "react";
import { useParams } from "react-router-dom";
import SeoFromApi from "./SeoFromApi"; // adjust path if needed

const BlogSeoWrapper = () => {
  const { slug } = useParams();

  if (!slug) return null;

  return <SeoFromApi pageType="blog" slug={slug} />;
};

export default BlogSeoWrapper;
